import angular from 'angular';
import _ from 'lodash';
import ComponentsModule from '../components-module';
import { DiffPatcher } from 'jsondiffpatch/src/diffpatcher';
import { format, hideUnchanged } from 'jsondiffpatch/src/formatters/html';
import 'jsondiffpatch/public/formatters-styles/html.css';

const COMPONENT_NAME = 'jsonDiff';

angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, ($sce) => {
    function isRoot (context) {
      return typeof context.childName === 'undefined' && typeof context.parent === 'undefined';
    }

    function isInPath (context, pathPattern) {
      if (_.isString(pathPattern)) {
        pathPattern = pathPattern.split('/').reverse();
      }

      if (isRoot(context)) {
        return pathPattern[0] === '';
      }

      if (pathPattern[0] === context.childName || pathPattern[0] === '*') {
        return isInPath(context.parent, pathPattern.slice(1));
      }

      return false;
    }

    function performDiff (diffPatcher, oldVersion, newerVersion) {
      var delta = diffPatcher.diff(oldVersion, newerVersion);
      return $sce.trustAsHtml(format(delta, oldVersion));
    }

    return {
      template: '<div x-ng-bind-html=\'diffResult\' class=\'diff-pane\'></div>',
      replace: true,
      restrict: 'AE',

      scope: {
        oldVersion: '<',
        newerVersion: '<',
        showFullChanges: '<'
      },

      controller: function ($scope) {
        hideUnchanged();

        const options = {
          arrays: {
            detectMove: true,
            includeValueOnMove: true
          },

          textDiff: {
            minLength: 20
          },

          propertyFilter: function (name) {
            return name.slice(0, 1) !== '$';
          },

          cloneDiffValues: false
        };

        const diffPatcher = new DiffPatcher(options);

        var metaInfoFilter = function (context) {
          if (!$scope.showFullChanges) {
            if (isInPath(context, '/system') || isInPath(context, '/operations')) {
              context.setResult(undefined).exit();
            }
          }

          if (isInPath(context, '/status')) {
            context.setResult(undefined).exit();
          }
        };

        metaInfoFilter.filterName = 'metaInfoFilter';
        diffPatcher.processor.pipes.diff.before('texts', metaInfoFilter);

        $scope.$watch('showFullChanges', function () {
          $scope.diffResult = performDiff(diffPatcher, $scope.oldVersion, $scope.newerVersion);
        });
      }
    };
  });

export default COMPONENT_NAME;
